import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { BackendResponse } from '@qtek/shared/models';

@Injectable({
  providedIn: 'root',
})
export class WizardService {
  private http = inject(HttpClient);

  getSteps(): Observable<BackendResponse> {
    return this.http.get<BackendResponse>('/api/v2/config/wzd', {
      withCredentials: true,
    });
  }
}
